import axios from "axios";

export default function PurchaseorderDownloadService(orderId) {
  return axios.get(process.env.REACT_APP_API_HOST + "/purchase_order/" + orderId + "/downloadOfferRequestTemplate", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
